import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const humio = defineConnector({
  identifier: "humio",
  name: "Humio",
  tagLine: "Log aggregation and search",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ url }) =>
    url ? `${url}/.*` : "https://cloud\\.humio\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://library.humio.com/logscale-api/api-authentication.html](https://library.humio.com/logscale-api/api-authentication.html) to create an API token for the Humio API. LogScale sends that token as `Authorization: Bearer <token>`.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "baseUrl",
          label: "Humio base URL",
          placeholder: "https://cloud.humio.com",
          required: true,
          target: {
            kind: "configuration",
            field: "url",
          },
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://cloud.humio.com/health",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod, ...configuration }) => ({
      url:
        testUrl ?? (({ url }) => `${url}/api/v1/repositories`)(configuration),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
